// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> terra-view
// Generated: 2026-10-29T18:31:59.984Z
// Counts: 0 design, 45 content, 13 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>3-Bedroom Townhome Floor Plans at Terra View</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare Floor Plans and Pricing Online</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility at Terra View</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Terra View Amenities in San Antonio, FL</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Every three-bedroom townhome comes with granite countertops, luxury flooring, stainless steel appliances and smart-home tech, and Quinn handles the yard work, exterior maintenance and repairs, so your weekends stay yours. <a href=\"/amenities\">See every feature</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Smart, upscale townhomes, no yard work</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Quinn's plans for Terra View include a resort-style pool and clubhouse. Mirada's 15-acre lagoon is about four minutes away for swimming, kayaking and paddleboarding, and you can get a feel for the area on our <a href=\"/neighborhood\">neighborhood page</a>.</p>",
    "mappedField": null
  },
  "amenityhighlights.title": {
    "overrideType": "VALUE",
    "customValue": "<p>In-Home and Community Features</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "aroundthearea.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Easy Access to I-75 and Tampa</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Terra View Townhomes</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactdetails.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We Are Happy to Help</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhelp.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Leasing and Move-In Questions</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqsearch.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Terra View FAQs</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>See Our New Townhomes in San Antonio, FL</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Terra View: New Townhomes for Rent in San Antonio, FL</p>",
    "generatedValue": "<p>Brand-new rental townhomes in San Antonio, Florida</p>",
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Available Townhomes in San Antonio, FL</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open townhome, street by street.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Terra View, the community pool and clubhouse are a short walk from your door. Quinn handles the yard work and exterior upkeep, so your weekends stay free for both. See more on our <a href=\"/amenities\">amenities page</a>.</p>",
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Life Near Wesley Chapel and Tampa at Terra View</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Enjoy quiet, small-town Pasco County living with I-75 and State Road 52 close by for quick drives to Wesley Chapel, Tampa and Saint Leo University. Weekends can mean errands at The Market at Mirada or an afternoon at Mirada Lagoon. <a href=\"/neighborhood\">Explore the neighborhood</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Small-town San Antonio, just off I-75</p>",
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Terra View Pet Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Quinn handles the yard work, so you get more time for walks, whether that's a stroll on the paved Withlacoochee State Trail or a trip out to the forest trails at Withlacoochee River Park. Max's Pet Market &amp; Salon at Mirada is nearby for natural food and grooming. The <a href=\"/pet-policy\">full pet policy</a> has the details.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Pets are welcome at Terra View</p>",
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Terra View Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>3-Bedroom Rental Townhomes at Terra View</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You for Contacting Terra View</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyou.title": {
    "overrideType": "VALUE",
    "customValue": "<p>What Happens Next</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourgallery.title": {
    "overrideType": "VALUE",
    "customValue": "<p>See Our New San Antonio, FL Townhomes for Yourself</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour of Terra View</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>See a Terra View townhome in person whenever it suits you with a <a href=\"/schedule-a-tour\">self-guided tour</a>, or meet the leasing team for a guided walkthrough.</p>",
    "mappedField": null
  },
  "touroptions.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Designed for Everyday Comfort</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tours-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tour Townhomes for Rent in San Antonio, FL</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Explore Terra View's three-bedroom, 2.5-bath townhomes from anywhere: pick a tour from the list and look around at your own pace, or <a href=\"/schedule-a-tour\">book a self-guided tour</a> to see them in person.</p>",
    "mappedField": null
  },
  "virtualtourembed.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore a 3-Bedroom Rental Townhome from Anywhere</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Poolside Weekends"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "The community pool is the easy way to cool off on a hot Pasco County afternoon, and there's no lawn to mow first."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse Gatherings"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "The clubhouse gives neighbors a shared place to meet up, catch up and get to know the people next door."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Room to Focus"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "With three bedrooms in every townhome, one can easily become a quiet home office, with smart-home technology built in."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086ae-df4a-76f8-b783-bc2e1ab78a5b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Shaded baseball fields at San Antonio Athletic Complex & Community Garden"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "San Antonio Athletic Complex & Community Garden"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167755/01a086b1-2214-72aa-ba8c-809f1e273c92.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Paved Withlacoochee State Trail at the Owensboro Junction Trailhead near Terra View"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Withlacoochee State Trail"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
